<mat-dialog-content class="ai-info-dialog">
	<div class="dialog-header nice-scroll">
		<div class="title-row">
			<mat-icon class="title-icon" svgIcon="smart-stars"></mat-icon>
			<h2 mat-dialog-title>{{ 'ai_image_analysis' | translate }}</h2>
		</div>
		<button mat-icon-button mat-dialog-close>
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="content-sections">
		<div class="content-section">
			<div class="icon-wrapper light-surface">
				<mat-icon>auto_fix_high</mat-icon>
			</div>
			<div class="section-content">
				<h3>{{ 'ai_analysis_title' | translate }}</h3>
				<p>{{ 'ai_analysis_description' | translate }}</p>
			</div>
		</div>

		<div class="content-section">
			<div class="icon-wrapper light-success">
				<mat-icon>security</mat-icon>
			</div>
			<div class="section-content">
				<h3>{{ 'ai_privacy_title' | translate }}</h3>
				<p>{{ 'ai_privacy_notice' | translate }}</p>
			</div>
		</div>

		<div class="content-section">
			<div class="icon-wrapper light-info">
				<mat-icon>info</mat-icon>
			</div>
			<div class="section-content">
				<h3>{{ 'ai_disclaimer_title' | translate }}</h3>
				<p>{{ 'ai_results_disclaimer' | translate }}</p>
			</div>
		</div>

		<div class="content-section">
			<div class="icon-wrapper light-warning">
				<mat-icon>language</mat-icon>
			</div>
			<div class="section-content">
				<h3>{{ 'ai_language_title' | translate }}</h3>
				<p>{{ 'ai_language_description' | translate }}</p>
			</div>
		</div>
	</div>

	<p class="ai-info-dialog-footer">
		{{ 'ai_info_dialog_footer' | translate }}
	</p>
</mat-dialog-content>
